import {getEnvConfig} from '@web-catalog/env';
import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';

import {makeResponseSafe} from '@utils/omicron';
import {getDeviceInfo} from '@utils/omicron/getDeviceInfo';

import {OMICRON_DEFAULT_RESPONSE} from './constants';
import {OmicronConfigSchema, OmicronContent, OmicronDTO} from './types';

export const omicronApi = wretch().addon(QueryStringAddon).options({
  credentials: 'include',
  cache: 'no-store',
});

export const getOmicronABResponse: () => Promise<OmicronDTO> = async () => {
  const {OMICRON_APP_ID, STAGE, OMICRON_URL} = getEnvConfig();
  const {device, os} = getDeviceInfo();

  const omicronQuery = {
    config_id: OMICRON_APP_ID,
    env: STAGE,
    service: 'vk-store-web-catalog',
    device_type: device,
    os: os,
  };

  try {
    return await omicronApi
      .url(`${OMICRON_URL}/api/v1/get`)
      .query(omicronQuery)
      .get()
      .json<OmicronDTO>((json) =>
        makeResponseSafe<OmicronContent>(OmicronConfigSchema, json),
      );
  } catch {
    return OMICRON_DEFAULT_RESPONSE;
  }
};
